module.exports = __webpack_public_path__ + "static/media/icon_qr_code_selected.8af15b4e.svg";